module.exports = __webpack_public_path__ + "img/engine-diagram.svg";